import React from 'react';
import { connect } from 'react-redux';
import { appContext } from '../../util/decorators';
import FollowButton from '../Page/FollowButton.jsx';

@connect()
@appContext
export default class SocialArea extends React.PureComponent {
  render() {
    const t = this.context.app.t;

    return (
      <div className="social-area">
        <p>{t('SocialArea.social_blurb')}</p>

        <FollowButton name="facebook" label="Facebook" />
        <FollowButton name="twitter" label="Twitter" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Sidebar/SocialArea.jsx